import { useNavigate } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import type { DirectorOrgFilter } from "@/api/types";

/**
 * S5 Header filter (AC-DH-008, decision D). Default «Вся компанія» → drill to a
 * team/supervisor scope. The filter changes ONLY the read/drilldown scope — it
 * NEVER unlocks write/action (read-only surface, D2=C). P0: selecting a team
 * navigates to the team-scoped client registry (read-only drilldown).
 */
export function DirectorHeaderFilter({ filter }: { filter: DirectorOrgFilter }) {
  const navigate = useNavigate();
  return (
    <div className="relative inline-flex items-center">
      <select
        aria-label="Фільтр за командою"
        defaultValue="__all__"
        onChange={(e) => {
          if (e.target.value !== "__all__") navigate(`/clients?scope=team&teamId=${e.target.value}`);
        }}
        className="appearance-none rounded-lg border border-border bg-card py-1.5 pl-3 pr-8 text-[12.5px] font-semibold text-foreground"
      >
        <option value="__all__">Вся компанія</option>
        {filter.teams.map((t) => (
          <option key={t.teamId} value={t.teamId}>
            {t.teamName}
            {t.supervisorName ? ` · ${t.supervisorName}` : ""}
          </option>
        ))}
      </select>
      <ChevronDown className="pointer-events-none absolute right-2.5 h-4 w-4 text-muted-foreground" />
    </div>
  );
}
